import React from "react";
import { DownloadOutlined } from "@ant-design/icons";
import { Button, Space, Typography, message } from "antd";
import * as XLSX from "xlsx";
import { useLazyGetAllMarketplaceOrdersQuery } from "../../api/marketplace/MarketplaceOrdersApi";
import {
  createMarketplaceOrdersWorkbook,
  marketplaceOrdersFilename,
} from "./exportMarketplaceOrders";

const { Paragraph, Title } = Typography;

export default function ExportOrdersPage() {
  const [getAllMarketplaceOrders, { isFetching }] = useLazyGetAllMarketplaceOrdersQuery();

  const handleExport = async () => {
    try {
      const result = await getAllMarketplaceOrders(undefined, false).unwrap();
      if (result.Items.length === 0) {
        message.warning("No marketplace orders to export");
        return;
      }

      const workbook = createMarketplaceOrdersWorkbook(result.Items);
      XLSX.writeFile(workbook, marketplaceOrdersFilename());
      message.success(`Exported ${result.Count} marketplace orders successfully`);
    } catch (error) {
      console.error("Marketplace orders export error:", error);
      message.error("Failed to export marketplace orders. Please try again.");
    }
  };

  return (
    <Space direction="vertical" size="middle">
      <Title level={3}>Export Orders</Title>
      <Paragraph>
        Download all marketplace orders in a single Excel workbook.
      </Paragraph>
      <Button
        type="primary"
        icon={<DownloadOutlined />}
        loading={isFetching}
        onClick={handleExport}
      >
        Export All Orders
      </Button>
    </Space>
  );
}
